<mat-card class="card-content full-height-container backdrop" id="task-component-bulk">
  <mat-card-header class="mg-b-m">
    <div class="header-title">
      <mat-card-title class="primary-font-color">{{ title }}</mat-card-title>
      <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
    </div>
  </mat-card-header>
  <mat-card-content class="form-container">
    <div *ngIf="updateStage != 3">
      <div *ngIf="featureComponentMode == FeatureComponentMode.BULK_LICENSE" class="full-height-container">
        <form [formGroup]="formGroup" id="bulkUpdateForm">
          <div class="flex-row toggle-block custom-container mg-b-m">
            <div class="custom-left-container">
              <ag-three-state-selector
                [formCtrl]="this.getFormControl('hasTableauLicense')"
                label="Has Tableau License?"
                noLabel="Un-License"
                yesLabel="License"
                [yesValue]="'true'"
                [noValue]="'false'"
                [showUndeterminedValue]="false"
              ></ag-three-state-selector>
            </div>
            <div class="custom-left-container" >
              <ag-three-state-selector *ngIf="this.formGroup.controls.hasTableauLicense?.value == 'true'"
                [formCtrl]="this.getFormControl('tableauLicenseIsPermanent')"
                label="Is Tableau License Permanent?"
                noLabel="No"
                yesLabel="Yes"
                [yesValue]="'true'"
                [noValue]="'false'"
                [showUndeterminedValue]="false"
              ></ag-three-state-selector>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="updateStage == 3" class="mg-b-m">
      <div class="bulk-update-progress-panel">
        <div class="bulk-update-progress-top-icon">
          <i class="fa-sharp fa-light fa-table fa-5x"></i>
        </div>
        <div class="flex-row flex-g-m">
          <div>
            <span>Processing Rows ({{ updateStatus.numberOfProcessedRows }} of {{ updateStatus.totalNumberOfRows }})</span>
          </div>
          <div class="right-align">
            <h3>{{ processedPercentage() }}%</h3>
          </div>
        </div>
        <div class="progress-bar-container">
          <mat-progress-bar color="primary" mode="determinate" value="{{processedPercentage()}}"></mat-progress-bar>
        </div>
        <div class="flex-row flex-g-m">
          <div>
            <span>Successful Rows ({{ updateStatus.numberOfSuccessRows }} of {{ updateStatus.numberOfProcessedRows }}) </span>
          </div>
          <div class="right-align">
            <h3>{{ successPercentage() }}%</h3>
          </div>
        </div>
        <div class="progress-bar-container">
          <mat-progress-bar color="accent" mode="determinate" value="{{successPercentage()}}"></mat-progress-bar>
        </div>
        <div *ngIf="updateStatus.markUnchangedRecord" class="flex-row flex-g-m">
          <div>
            <span>Unchanged Rows ({{ updateStatus.numberOfUnchangedRows }} of {{ updateStatus.numberOfProcessedRows }}) </span>
          </div>
          <div class="right-align">
            <h3>{{ unchangedPercentage() }}%</h3>
          </div>
        </div>
        <div *ngIf="updateStatus.markUnchangedRecord" class="progress-bar-container">
          <mat-progress-bar color="accent" mode="determinate" value="{{unchangedPercentage()}}"></mat-progress-bar>
        </div>
        <div class="flex-row flex-g-m">
          <div>
            <span>Unsuccessful Rows ({{ updateStatus.numberOfErrorRows }} of {{ updateStatus.numberOfProcessedRows }}) </span>
          </div>
          <div class="right-align">
            <h3>{{ errorPercentage() }}%</h3>
          </div>
        </div>
        <div class="progress-bar-container">
          <mat-progress-bar color="warn" mode="determinate" value="{{errorPercentage()}}"></mat-progress-bar>
        </div>
      </div>
    </div>
    <div>
      <div class="flex-row flex-g-s action-buttons">
        <button (click)="startProcessing()" *ngIf="updateStage == 2" [disabled]="this.featureComponentMode != FeatureComponentMode.UPLOAD && !this.hasAnyEdits()"
                color="primary" form="bulkUpdateForm" mat-raised-button type="submit">
          <mat-icon class="material-symbols-outlined">save</mat-icon>
          {{ submitButtonText }}
        </button>
        <button (click)="resetForm()" *ngIf="updateStage == 2 && featureComponentMode != FeatureComponentMode.UPLOAD" [disabled]="!this.hasAnyEdits()" mat-button
                type="button">
          <mat-icon class="material-symbols-outlined">cancel</mat-icon>
          Reset
        </button>
        <button (click)="abort()" *ngIf="updateStage == 3" [disabled]="!saveInProgress" mat-button>
          <mat-icon class="material-symbols-outlined">cancel</mat-icon>
          Abort
        </button>
        <button (click)="resetForm(); close()" *ngIf="updateStage == 2 || updateStage == 3" mat-button type="button">
          <i class="fa-sharp fa-light fa-xmark-large"></i> Close
        </button>
      </div>
      <div *ngIf="updateStage != 1" class="flex-row full-width mg-t-m">
        <ag-grid-angular (gridReady)="onGridReady($event)"
                         [columnDefs]="tableColumns"
                         [rowData]="selectedRows"
                         [suppressPropertyNamesCheck]="true"
                         class="ag-theme-quartz record-display-table"></ag-grid-angular>
      </div>
    </div>

  </mat-card-content>
</mat-card>
